import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-submit-fail-dialog",
  templateUrl: "./submit-fail-dialog.component.html",
  styleUrls: ["./submit-fail-dialog.component.scss"]
})
export class SubmitFailDialogComponent {
  showWhatsappButton: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      isWithEHailing: boolean;
      isAffiliate?: boolean;
      isTpftVehicleOverage?: boolean;
      partnerCode?: string;
      insuranceType: string;
      isVehicleUnderAged: boolean;
      isVehicleOverAged: boolean;
    },
    public dialogRef: MatDialogRef<SubmitFailDialogComponent>,
    public translate: TranslateService
  ) {
    
    if (!data.isAffiliate) {
      if (data.insuranceType == "TPFT" || data.insuranceType == "TP") {
        this.showWhatsappButton = (data.isVehicleOverAged && !data.isVehicleUnderAged);
      }
    }
  }

  whatsppRedirect() {
    const whatsappNumber = 60182822320;
    const entityName = "Policystreet";
    let whatsappContent = "";
    let lang = this.translate.currentLang == "en" ? "en" : "ms";
    whatsappContent =
      lang == "ms"
        ? `Hai ${entityName}, saya ingin tahu dengan lebih lanjut mengenai cukai jalan dan insurans kenderaan`
        : `Hi ${entityName}, I would like to know more about road tax and car insurance`;

    let url = `https://api.whatsapp.com/send?phone=${whatsappNumber}&text=${encodeURIComponent(
      whatsappContent
    )}&source=&data=&app_absent=&lang=${lang}`;

    window.open(url, "_blank");
  }

  onBackToHome(): void {
    window.location.reload();
  }
}
